import { render, staticRenderFns } from "./DepartmentOverview.vue?vue&type=template&id=08e6737a"
import script from "./DepartmentOverview.vue?vue&type=script&lang=js"
export * from "./DepartmentOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports